import { takeEvery, select, put, call } from 'redux-saga/effects'
import moment from 'moment'

import {
  FEED_SET_TAB,
  FEED_STORIES,
  FEED_STORIES_LOAD_MORE,
  FEED_STORIES_SCROLL,
  FEED_STORIES_UNREAD_COUNT,
  FEED_STORY_ACTIVITY,
} from '../actionTypes'
import {
  getFeedPendingGetStories,
  getFeedStoriesPagination,
  getFeedPendingGetStoriesLoadMore,
  getFeedLoadedGetStoriesLoadMore,
  getFeedFilterByRange,
  getLastItemInRecentList,
} from '../selectors'
import { showError } from 'store/entities/analytics/actions'
import {
  enableFeedStoriesGetPending,
  feedStories,
  enableFeedStoriesLoadMorePending,
  feedStoriesLoadMore,
} from '../actions'
import makeAPIRequest from 'store/entities/api/sagas'
import { GET_STORIES } from 'app/constants/api/feed'
import { FEED_RANGE, TAB_STORIES } from 'app/constants/feed'
import { LOAD_STORY_ACTIVITY, MARK_STORIES_READ, STORIES_UNREAD_COUNTER } from 'app/constants/reactions'

export default function* getStoriesSaga(params) {
  yield* [
    takeEvery(FEED_STORIES.GET.REQUEST, handleGetStoriesRequest),
    takeEvery(FEED_STORIES_LOAD_MORE.GET.REQUEST, handleLoadMoreStoriesRequest),
    takeEvery(FEED_STORIES_SCROLL, handleFeedStoriesScroll),
    takeEvery(FEED_STORY_ACTIVITY.GET.REQUEST, handleLoadActivity, params),
    takeEvery(FEED_SET_TAB, handleMarkAsRead, params),
    takeEvery(FEED_STORIES_UNREAD_COUNT.GET.REQUEST, handleLoadUnreadCounter, params),
  ]
}

export function* handleGetStoriesRequest() {
  try {
    const pending = yield select(getFeedPendingGetStories)
    if (!pending) {
      yield put(enableFeedStoriesGetPending)
      const data = yield makeGetStoriesRequest()
      yield put(feedStories.get.success(data))
    }
  } catch (badResponse) {
    showError()
    yield put(feedStories.get.fail(badResponse))
  }
}

export function* handleLoadMoreStoriesRequest() {
  try {
    const pending = yield select(getFeedPendingGetStoriesLoadMore)
    if (!pending) {
      yield put(enableFeedStoriesLoadMorePending)
      const data = yield makeGetStoriesRequest(true)
      yield put(feedStoriesLoadMore.get.success(data))
    }
  } catch (badResponse) {
    showError()
    yield put(feedStoriesLoadMore.get.fail(badResponse))
  }
}

export function* handleFeedStoriesScroll({ payload: { scrollTop, clientHeight, scrollHeight } }) {
  const loaded = yield select(getFeedLoadedGetStoriesLoadMore)
  const range = yield select(getFeedFilterByRange)
  const lastItem = yield select(getLastItemInRecentList)
  const allowRequest = FEED_RANGE.all === range || moment(lastItem.get('timestamp')) > moment().day(-range)
  if (!loaded && scrollTop.stories + clientHeight >= scrollHeight && allowRequest) {
    yield put(feedStoriesLoadMore.get.request())
  }
}

export function* makeGetStoriesRequest(isNext = false) {
  const storiesPagination = yield select(getFeedStoriesPagination)
  const page = storiesPagination.get('page') + isNext
  const limit = storiesPagination.get('limit')
  const { data } = yield call(makeAPIRequest, `${GET_STORIES}?page=${page}&limit=${limit}&sort=createdAt&desc=1`, {
    method: 'GET',
  })
  return data
}

export function handleLoadActivity(params, { payload }) {
  const { activityUserStoryId, activityId } = payload.data
  params.socket.emit(LOAD_STORY_ACTIVITY, {
    activityUserStoryId,
    activityId,
  })
}

export function handleMarkAsRead(params, { payload }) {
  const { tab } = payload
  if (tab === TAB_STORIES) {
    params.socket.emit(MARK_STORIES_READ)
  }
}

export function handleLoadUnreadCounter(params) {
  params.socket.emit(STORIES_UNREAD_COUNTER)
}
